import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import ENV from '../../env'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    examGroups: [],
    examGroup: {} 
  },
  mutations: {
    index(state, payload) {
      state.examGroups = payload
    },
    show(state,payload) {
      state.examGroup = payload
    },
    addToIndex (state, payload) {
      state.examGroups.push(payload)
    },
    update (state, payload) {
      state.examGroups = state.examGroups.map((examGroup) => {
        if (examGroup.id == payload.id) {
          examGroup = payload
        }
        return examGroup
      })
    },
    removeExamGroup(state, payload) {
      state.examGroups = state.examGroups.filter((examGroup) => examGroup.id != payload)
    }
  },
  actions: {
    index ({commit}, payload) {
      return axios.get(`${ENV.API_URL}/api/exam_groups${payload ? payload : ''}`).then((res) => {
        commit('index', res.data)
        return res.data
      })
    },
    show({commit}, payload) {
      return axios.get(`${ENV.API_URL}/api/exam_groups/${payload}`).then((res) => {
        commit('show', res.data)
      })
    },
    create({commit}, payload) {
      return axios.post(`${ENV.API_URL}/api/exam_groups`, payload).then((res) => {
        commit('show', res.data)
        commit('addToIndex', res.data)
      })
    },
    update({commit}, payload) {
      axios.put(`${ENV.API_URL}/api/exam_groups/${payload.id}`, payload).then((res) => {
        commit('update', res.data)
      })
    },
    deleteGroup ({commit}, payload) {
      return axios.delete(`${ENV.API_URL}/api/exams/${payload.eventId}/exam_groups/${payload.eventGroupId}`, payload).then((res) => {
        commit('removeExamGroup', res.data)
      })
    },
  },
  getters: {
    examGroups: state => {
      return state.examGroups
    },
    examGroup: state => {
      return state.examGroup
    }
  },
  modules: {
  }
}
